import UserPermissionsService from '@/service/UserPermissionsService'

let usersFilter = {
    role: null,
    tags: [],
    users: [],
}

const initialState = {
    allUsers: [],
    allUsersTags: [],
    allUserTableList: [],
    usersFilter: { ...usersFilter },
    filteredTable: [],
    loading: false,
    tags: [],
    newTagName: null,
    newTag: {},
    addTagClick: false,
    userTags: {},
    staticUserTableList: [],
    filteredUsersId: [],
}

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async fetchAllUsers({ commit, state }) {
            try {
                state.loading = true
                let resp = await UserPermissionsService.getAllUsers()
                if (resp.status === 200) {
                    commit('setAllUsers', resp?.data)
                    commit('setUserTags', resp?.data)
                    commit('setStaticUserTabelList', resp?.data)
                    state.loading = false
                }
            } catch (e) {
                console.log(e)
            }
        },
        async fetchAllUsersTags({ commit }, id = null) {
            try {
                let params = { userId: id ? parseInt(id) : null }
                let resp = await UserPermissionsService.getAllUsersTags(params)
                if (resp.status === 200) {
                    await commit('setAllUsersTags', resp?.data)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async editUsersTags({ dispatch }, data) {
            try {
                let resp = await UserPermissionsService.putUsersTags(data)
                if (resp.status === 200) {
                    dispatch('fetchAllUsersTags')
                }
            } catch (e) {
                console.log(e)
            }
        },
        async fetchAllTags({ commit }) {
            try {
                let resp = await UserPermissionsService.getAllTags()
                if (resp.status === 200) {
                    commit('setTags', resp?.data)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async addNewTag({ commit, state, dispatch }) {
            try {
                let resp = await UserPermissionsService.postNewTag(state.newTagName, state.newTag)
                if (resp.status === 200) {
                    commit('setResetNewTag')
                    commit('setTags', resp?.data)
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'New tag created!',
                            type: 'success',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.log(e)
            }
        },
        async editTag({ commit }, editTagData) {
            try {
                let resp = await UserPermissionsService.putTag(editTagData)
                if (resp.status === 200) {
                    commit('setTags', resp?.data)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async deleteTags({ commit, dispatch }, deleteTagsData) {
            try {
                let resp = await UserPermissionsService.deleteTag(deleteTagsData)
                if (resp.status === 200) {
                    commit('setTags', resp?.data)
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Tag deleted!',
                            type: 'success',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.log(e)
            }
        },
    },
    mutations: {
        setAllUsers(state, data) {
            state.allUsers = data
            state.allUserTableList = data
        },
        setUserTags(state, data) {
            let getUserTags = []
            Object.entries(state.allUsersTags).forEach(tag => {
                if (tag[1]?.includes(data.id)) {
                    getUserTags.push(tag[0])
                }
            })

            data['tags'] = getUserTags
            state.userTags = getUserTags
            state.staticUserTableList = data
        },
        setStaticUserTabelList(state, data) {
            data?.forEach(user => {
                let getUserTags = []
                Object.entries(state.allUsersTags).forEach(tag => {
                    if (tag[1]?.includes(user.id)) {
                        getUserTags.push(tag[0])
                    }
                })
                user['tags'] = getUserTags
            })
            state.staticUserTableList = data
            if (state.filteredUsersId.length > 0) {
                state.allUserTableList = []
                for (let id of state.filteredUsersId) {
                    let user = state.staticUserTableList.filter(user => user.id === id)
                    if (user) {
                        state.allUserTableList.push(user[0])
                    }
                }
            }
        },
        setFilteredUsers(state, data) {
            state.allUserTableList = data
            state.filteredUsersId = data.map(user => user.id)
        },
        setLoading(state, data) {
            state.loading = data
        },
        setNewTagName(state, data) {
            state.newTagName = data
        },
        setResetNewTag(state) {
            Object.keys(state.newTag).forEach(key => {
                state.newTag[key] = []
            })
        },
        setNewTag(state, data) {
            Object.keys(data).forEach(key => {
                data[key] = []
            })
            state.newTag = { ...data }
        },
        setTags(state, data) {
            state.tags = data
        },
        setAddNewTag(state, data) {
            state.newTag = { ...data }
        },
        setAllUsersTags(state, data) {
            state.allUsersTags = data
        },
    },
}
